/* eslint-disable prettier/prettier */
/* eslint-disable no-useless-escape */
/* eslint-disable prettier/prettier */
import { is } from "bpmn-js/lib/util/ModelUtil";
import elementHelper from "bpmn-js-properties-panel/lib/helper/ElementHelper";
import { forEach } from "lodash";
import { query as domQuery, closest as domClosest } from "min-dom";

import { GRID } from "../containers/smartForms/components/constants";

export const listTaskFields = [];

export function getPropertiesElement(element, type) {
  let data = null;
  forEach(element.values, function (elem) {
    if (elem.$type === type) {
      data = elem;
    }
  });
  return data;
}

export function isExtensionElements(element) {
  return is(element.extensionElements, "bpmn:ExtensionElements");
}

export function getDetailProps(fields, parentId) {
  const formfields = [];
  let ntype = null;
  let jsondata = {};

  forEach(fields, function (prop) {
    if (
      prop.properties &&
      prop.properties.values &&
      prop.properties.values[0] &&
      prop.properties.values[0].$attrs &&
      prop.properties.values[0].$attrs.smart
    ) {
      jsondata = JSON.parse(prop.properties.values[0].value);
      ntype = jsondata.type;
    } else {
      ntype = null;
      jsondata = {};
    }
    if (ntype === GRID) {
      const griddata = getGridDetails(jsondata, prop.id);
      Array.prototype.push.apply(formfields, griddata);
    }

    const item = {
      id: prop.id,
      label: prop.label,
      parentId,
      type: ntype,
      properties: jsondata,
    };
    formfields.push(item);
  });
  return formfields;
}

export function getGridDetails(fields, parentId) {
  const formfields = [];
  for (let linha = 0; linha < fields.items.length; linha++) {
    const rows = fields.items[linha];
    for (let column = 0; column < rows.items.length; column++) {
      const col = rows.items[column];

      for (let content = 0; content < col.items.length; content++) {
        const cont = col.items[content];

        formfields.push({
          id: cont.id,
          label: cont.label,
          parentId,
          type: cont.type,
          properties: cont,
        });
      }
    }
  }
  return formfields;
}

export function returnsbpmndefinitions(element) {
  if (!element) return;
  if (element.$type === "bpmn:Definitions") return element;
  return returnsbpmndefinitions(element.$parent);
}

export function getTaskFields(
  elements,
  selectedTaskName,
  issub = false,
  listAll = false,
) {
  let formfields = [];
  const listexistFields = [];
  const listTaskFields = !issub ? [] : null;

  forEach(elements, function (elem) {
    let data = null;
    if (
      (elem.id !== selectedTaskName || listAll) &&
      (elem.$type === "bpmn:StartEvent" || elem.$type === "bpmn:UserTask")
    ) {
      if (isExtensionElements(elem)) {
        data = getPropertiesElement(elem.extensionElements, "camunda:FormData");

        if (data && data.fields && data.fields.length > 0) {
          const fields = getDetailProps(data.fields, elem.id);
          const listAdd = [];
          for (let i = 0; i < fields.length; i++) {
            // eslint-disable-next-line no-loop-func
            const existField = listexistFields.find(function (f) {
              if (f.id === fields[i].id) {
                return true;
              }
              return false;
            });
            if (!existField) {
              listAdd.push(fields[i]);
              listexistFields.push(fields[i]);
              listTaskFields.push(fields[i]);
            }
            listAdd.push(fields[i]);
            listTaskFields.push(fields[i]);
          }

          const taskform = {
            activityName:
              elem.name && elem.name.length > 0 ? elem.name : elem.id,
            id: elem.id,
            fields: listAdd,
          };
          formfields.push(taskform);
        }
      }
    } else if (elem.$type === "bpmn:SubProcess") {
      const SubProcess = getTaskFields(
        elem.flowElements,
        selectedTaskName,
        true,
        listAll,
      );
      formfields = formfields.concat(SubProcess);
    }
  });
  return formfields;
}

export function getUniqueTaskFields(businessObject) {
  const bpmnDefinitions = returnsbpmndefinitions(businessObject);

  let formfields = [];
  if (bpmnDefinitions && bpmnDefinitions.rootElements) {
    const rootElements = bpmnDefinitions.rootElements.find(function (elem) {
      if (elem.$type === "bpmn:Process") {
        return true;
      }
      return false;
    });

    const allFormfields = getTaskFields(
      rootElements.flowElements,
      businessObject.id,
      false,
      true,
    );

    formfields = allFormfields
      .reduce((prev, current) => {
        if (current && current.fields && current.fields.length > 0) {
          return prev.concat(current.fields);
        }
        return prev;
      }, [])
      .filter((value, index, self) => {
        return index === self.findIndex((obj) => obj.id === value.id);
      });
  }

  return formfields;
}

export function getSelectBox(node, id) {
  const currentTab = domClosest(node, "div.bpp-properties-tab");
  const query =
    "select[name=selectedExtensionElement]" +
    (id ? "[id=cam-extensionElements-" + id + "]" : "");
  return domQuery(query, currentTab);
}

export function getScriptParameterByName(inputParameters, paramName) {
  if (inputParameters) {
    for (let i = 0; i < inputParameters.length; i++) {
      if (
        inputParameters[i].name === paramName &&
        inputParameters[i].definition
      ) {
        return converToJsonObject(inputParameters[i].definition.value);
      }
    }
  }
  return {};
}

export function convertToCamundaScriptValue(value) {
  const newValue = (value && value.replaceAll("'", "\\'")) || "{}";
  return `S('${newValue}')`;
}

export function converToJsonObject(value) {
  const hasValue = value && value.startsWith("S('") && value.endsWith("')");

  if (hasValue) {
    // remove o "S('')" da string
    const jsonString = value.substring(3, value.length - 2);
    try {
      return JSON.parse(jsonString.replaceAll("\\'", "'"));
    } catch (err) {
      console.error(err);
    }
  }

  return {};
}

export function getDocumentFromServiceTasks(
  elements,
  selectedTaskName,
  issub = false,
) {
  let documents = [];

  forEach(elements, function (elem) {
    if (
      elem.id !== selectedTaskName &&
      elem.$type === "bpmn:ServiceTask" &&
      elem.$attrs &&
      (elem.$attrs["camunda:registrararquivardocumento"] ||
        elem.$attrs["camunda:gerarpdfnew"])
    ) {
      if (isExtensionElements(elem)) {
        const inputOutput = getPropertiesElement(
          elem.extensionElements,
          "camunda:InputOutput",
        );

        if (inputOutput) {
          if (elem.$attrs["camunda:registrararquivardocumento"]) {
            const regArqConfig = getScriptParameterByName(
              inputOutput.inputParameters,
              "registrarDocumentoWithPathConfig",
            );

            if (regArqConfig.documentResult) {
              documents.push({
                id: regArqConfig.documentResult,
                name: regArqConfig.documentTitle || regArqConfig.documentResult,
                type: "Documento",
              });
            }
          } else if (elem.$attrs["camunda:gerarpdfnew"]) {
            const gerarPdfConfig = getScriptParameterByName(
              inputOutput.inputParameters,
              "generatePdfFromTemplateWithPathConfig",
            );

            if (gerarPdfConfig.documentResult) {
              documents.push({
                id: gerarPdfConfig.documentResult,
                name:
                  gerarPdfConfig.documentTitle || gerarPdfConfig.documentResult,
                type: "Documento",
              });
            }
          }
        }
      }
    } else if (elem.$type === "bpmn:SubProcess") {
      const SubProcess = getDocumentFromServiceTasks(
        elem.flowElements,
        selectedTaskName,
        true,
      );
      documents = documents.concat(SubProcess);
    }
  });
  return documents;
}

export function getUniqueDocumentServiceFields(businessObject) {
  const bpmnDefinitions = returnsbpmndefinitions(businessObject);

  let documentServiceFields = [];
  if (bpmnDefinitions && bpmnDefinitions.rootElements) {
    const rootElements = bpmnDefinitions.rootElements.find(function (elem) {
      if (elem.$type === "bpmn:Process") {
        return true;
      }
      return false;
    });

    const allDocumentSeviceFields = getDocumentFromServiceTasks(
      rootElements.flowElements,
      businessObject.id,
      false,
    );

    documentServiceFields = allDocumentSeviceFields.filter(
      (value, index, self) => {
        return index === self.findIndex((obj) => obj.id === value.id);
      },
    );
  }

  return documentServiceFields;
}

export function modifyExtensionElement(
  propertyName,
  propertyValue,
  element,
  businessObject,
  bpmnFactory,
  modeling,
) {
  let extensionElements = businessObject.get("extensionElements");

  let camundaProperties = null;
  let findConfig = false;

  if (!propertyValue) {
    // remove propriedade caso não tenha valor
    if (extensionElements) {
      camundaProperties = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:Properties") {
          return true;
        }
        return false;
      });

      if (camundaProperties && camundaProperties.values) {
        const propertyConfigIndex = camundaProperties.values.findIndex(
          function (elem) {
            if (elem.name === propertyName) {
              return true;
            }
            return false;
          },
        );

        if (propertyConfigIndex !== -1) {
          // remoção
          camundaProperties.values.splice(propertyConfigIndex, 1);
        }

        const camundaPropertiesIndex = extensionElements.values.findIndex(
          function (elem) {
            if (elem.$type === "camunda:Properties") {
              return true;
            }
            return false;
          },
        );

        if (camundaPropertiesIndex !== -1) {
          extensionElements.values[camundaPropertiesIndex] = camundaProperties;
        } else {
          extensionElements.values.push(camundaProperties);
        }

        businessObject.set("extensionElements", extensionElements);

        modeling.updateProperties(element, {});
      }
    }
  } else {
    if (!extensionElements) {
      extensionElements = elementHelper.createElement(
        "bpmn:ExtensionElements",
        { values: [] },
        businessObject,
        bpmnFactory,
      );
      camundaProperties = elementHelper.createElement(
        "camunda:Properties",
        { values: [] },
        extensionElements,
        bpmnFactory,
      );
    } else {
      camundaProperties = extensionElements.values.find(function (elem) {
        if (elem.$type === "camunda:Properties") {
          return true;
        }
        return false;
      });

      if (!camundaProperties) {
        camundaProperties = elementHelper.createElement(
          "camunda:Properties",
          { values: [] },
          extensionElements,
          bpmnFactory,
        );
      }

      if (camundaProperties.values === undefined) {
        camundaProperties.set("values", []);
      }
    }

    // atualizando a propriedade
    for (
      let idxProperty = 0;
      idxProperty < camundaProperties.values.length;
      idxProperty++
    ) {
      const camundaProperty = camundaProperties.values[idxProperty];
      if (camundaProperty.name === propertyName) {
        findConfig = true;
        camundaProperties.values[idxProperty] = elementHelper.createElement(
          "camunda:Property",
          { name: propertyName, value: propertyValue },
          camundaProperties,
          bpmnFactory,
        );
      }
    }

    if (!findConfig) {
      camundaProperties.values.push(
        elementHelper.createElement(
          "camunda:Property",
          { name: propertyName, value: propertyValue },
          camundaProperties,
          bpmnFactory,
        ),
      );
    }

    // atualizando camunda:Properties
    const camundaPropertiesIndex = extensionElements.values.findIndex(
      function (elem) {
        if (elem.$type === "camunda:Properties") {
          return true;
        }
        return false;
      },
    );

    if (camundaPropertiesIndex !== -1) {
      extensionElements.values[camundaPropertiesIndex] = camundaProperties;
    } else {
      extensionElements.values.push(camundaProperties);
    }

    businessObject.set("extensionElements", extensionElements);

    modeling.updateProperties(element, {});
  }
}

export function getExtensionElement(propertyName, businessObject) {
  const extensionElements =
    businessObject &&
    businessObject.get &&
    businessObject.get("extensionElements");

  if (extensionElements) {
    const extensionProperties = extensionElements.values.find(function (elem) {
      if (elem.$type === "camunda:Properties") {
        return true;
      }
      return false;
    });

    if (extensionProperties && extensionProperties.values) {
      for (
        let idxProperty = 0;
        idxProperty < extensionProperties.values.length;
        idxProperty++
      ) {
        const camundaProperty = extensionProperties.values[idxProperty];
        if (camundaProperty.name === propertyName) {
          return camundaProperty.value;
        }
      }
    }
  }

  return null;
}

export function escape(str) {
  return str
    .replace(/\n/g, "\\n")
    .replace(/[\t\r]+/g, "")
    .replace(/\"/g, '\\"');
}

export function unescape(str) {
  return str.replace(/\\n/g, "\n").replace(/\\"/g, '"');
}
